<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-user-view">
      <div id="user-data" >
        <!-- {{"Permissao adicionar "+canAddEmp}} -->
        <vx-card  class="mb-base" title="Filtros">
          <div class="vx-row">
            <div class="vx-col w-1/4  mb-5" >
    <label for="">Data de entrada</label>
           <vs-input
                  class="w-full"
                  icon-pack="feather"
                  icon-no-border
                  v-model="entry_date"
                  type="date"
                  v-validate="'required'"
                />
            </div>
            <div class="vx-col w-1/4  mb-5" >
              <label for="">Data de saida</label>
                     <vs-input
                            class="w-full"
                            icon-pack="feather"
                            icon-no-border
                            v-model="exit_date"
                            type="date"
                            v-validate="'required'"
                          />
                      </div>
                  
            
                      
   <div class="vx-col w-1/4  mb-5" >
    <label for="">Observação</label>
    <v-select  placeholder="selecione a observação" :options="['presente','ausente','antecipado','atrasado','folga','licença']"  v-model="note"></v-select>
        
            </div>
         
         
         
            <div class="vx-col w-1/4  mb-5" >
               <label for=""></label> <br>
                <vs-button  class="w-full" color="primary"  @click="getEmployees()">
                  Filtrar
                </vs-button>
                
            </div>
             <div class="vx-col w-1/4  mb-5" >
               <label for=""></label> <br>
                  <vs-button class="w-full" type="border" color="warning" @click="clean">Limpar</vs-button>
                
            </div>
           
  
           
            </div>
         
  
        </vx-card>
  
     
        <vx-card title="">
          <vs-divider></vs-divider>
          <div class="block overflow-x-auto">
        
  
  
  <vs-table  stripe v-model="selected"  :max-items="paginate" search :data="employees">
  <template  slot="header">
             <select @change="getEmployees"  class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" v-validate="'excluded:1,2,3'"  v-model="paginate" name="not_in_field" data-vv-as="selected">
      <option class="vs__selected-options" value="5">5</option>
      <option class="vs__selected-options" value="10">10</option>
      <option class="vs__selected-options" value="15">20</option>
      <option class="vs__selected-options" value="50">50</option>
       <option class="vs__selected-options" value="100">100</option>
       <option class="vs__selected-options" value="500">500</option>
        <option class="vs__selected-options" value="1000">1000</option>
      
    </select>
      <label class="ml-3 font-bold">Total: {{total}}</label>
            </template>
      <template slot="thead">
        <vs-th sort-key="entry_date">Data</vs-th>
        <vs-th sort-key="entry_date">Hora de entrada</vs-th>
        <vs-th sort-key="entry_date">Hora de saida</vs-th>
         <vs-th sort-key="entry_date">Atraso</vs-th>
        <vs-th sort-key="entry_date">Observação</vs-th>
        <vs-th></vs-th>
      </template>
  
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
  
          <vs-td :data="data[indextr].date">
            {{ data[indextr].date }}
          </vs-td>
          <vs-td >
            <span v-if="data[indextr].entry_date">
              {{ data[indextr].entry_date.slice(10) }}
            </span>
            <span class="font-bold whitespace-no-wrap" v-else>
              Sem marcação
            </span>
           
          </vs-td>
          <vs-td >
            <span v-if="data[indextr].exit_date">
              {{ data[indextr].exit_date.slice(10) }}
            </span>
            <span class="font-bold whitespace-no-wrap" v-else>
              Sem marcação
            </span>
           
          </vs-td>
  
  <vs-td :data="data[indextr].delay">
            {{ data[indextr].delay }}
          </vs-td>
          <vs-td >
              <vs-chip v-if="data[indextr].note=='presente'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='presente'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-success'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
          
              <vs-chip v-if="data[indextr].note=='ausente'" class="font-bold" :data="data[indextr].note=='ausente'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
           
              <vs-chip v-if="data[indextr].note=='justificada sem compesação'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='justificada sem compesação'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-warning'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
              <vs-chip v-if="data[indextr].note=='justificada com compesação'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='justificada sem compesação'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='licença'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='licença'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='férias'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='férias'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='atrasado'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='atrasado'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='trabalho de campo'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='trabalho de campo'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
                      <vs-chip v-if="data[indextr].note=='antecipado'" class="font-bold whitespace-no-wrap" :data="data[indextr].note=='antecipado'">
                          <div class="h-2 w-2 rounded-full mr-1" :class="'bg-primary'"></div>
                          <span>{{data[indextr].note }}</span>
                      </vs-chip>
          </vs-td>
  <vs-td>
     <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
         
                      <vs-button :disabled="data[indextr].note!='ausente'" color="success" size="small"  type="border" @click="openJustificar(tr)"> Justificar</vs-button>
               
                <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              </vs-td>
  </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    <vs-pagination class="mt-3" :total="totalPage" @change="getEmployees" v-model="currentPage"></vs-pagination>
    <!-- <pre> {{ selected }} </pre> -->
    
          </div>
          <div class="vx-row">
        <!-- <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto  mt-2" type="border" color="warning"  @click="clean">Limpar</vs-button>
            <vs-button class="ml-4 mt-2" @click="saveMarcar" >Marcar</vs-button>
          </div>
        </div> -->
      </div>
  
         
  
        </vx-card>
         
      </div>
  
      <vs-popup class="holamundo" title="Justificar Falta" :active.sync="popupJustificar">
      
         <div class="vx-row">
             <div class="vx-col w-full  mb-5" >
    <label for="">Motivo</label>
           <vs-input
                  class="w-full"
                  icon-pack="feather"
                  icon-no-border
                  v-model="description"
                  type="text"
                  v-validate="'required'"
                />
            </div>
            
             
            <div class="vx-col w-full mb-5" >
    <label for="">Comprovativo</label>
           <vs-input
                  class="w-full"
                  icon-pack="feather"
                  icon-no-border
                  name="file"
                  type="file"
                  v-validate="'required'"
                  @change="previewImage"
                   accept="image/*"
                />
            </div>
      
            
           
          </div>
  
  <div class="flex flex-wrap items-end flex-start">
        <vs-button class="ml-auto mt-2" @click="saveJustificar">Justificar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
  
        
      </div>
      </vs-popup>
    </div>
  </template>
  
  <script>
  import http from '../../../../http-common';
  import vSelect from 'vue-select'
  export default {
      components: {
      vSelect
    },
    data() {
      return {
        name:"",
        apelido:"",
        dataFormatada:"",
        selectedEmpName:[],
        selectedEmpSurname:[],
        emps:[],
        apelidos:[],
        note:"",
              totalPage:"",
        currentPage:"",
        paginate:15,
  
        dataEntrada:"",
        dataSaida:"",
        estado:"",
       users:[],
       selectedUser:"",
       permission_name:[],
       role_name:[],
       popupJustificar:false,
       err:"",
  employees:[],
  popupUpBaixar:false,
  
  exit_time:"",
   
        result:[],
  employee_id:[],
  attendance_id:[],
  entry_date:"",
  exit_date:"",
  note:"",
  attachment:"",
  falta:[],
  description:"",
  surname:"",
   name:"",
  selected: [],
        'tableList': [
          'vs-th: Component',
          'vs-tr: Component',
          'vs-td: Component',
          'thread: Slot',
          'tbody: Slot',
          'header: Slot'
        ],
        
  
      }
    },
  
    
      computed: { //todo: descontinuei essa parte veja o watch e o metodo verifypermissions
        // canListEmp(){
        //   for(let permission in this.selectedUser.permissions){
        //     console.log("permissao", this.selectedUser.permissions[permission].name)
        //     if(this.selectedUser.permissions[permission].name == "list Employee"){
        //       return true;
        //     }
        //   }
        //   return false;
        // },
        // canAddEmp(){
        //   for(let permission in this.selectedUser.permissions){
        //     console.log("permissao", this.selectedUser.permissions[permission].name)
        //     if(this.selectedUser.permissions[permission].name == "create Employee"){
        //       return true;
        //     }
        //   }
        //   return false;
        // }
      },
  
      mounted() {
        this.dataActual();
      this.initialize();
      this.getEmp();
      this.getCurrentUser();
    },
  
    methods: {
      initialize(){
        // this.getEmployees();
        this.dataActual()
      },
     
      getCurrentUser(){
      let authUser = localStorage.getItem('user');
      var authUserObject = JSON.parse(authUser);
       this.name   = authUserObject.name;
       this.surname   = authUserObject.surname;
    //    this.image = authUserObject.image;
    //    this.id = authUserObject.id;
    },
  
  clean(){
    this.note="",
    this.exit_time="",
    this.entry_date="",
    this.getEmployees()
  },
  
  
  mapear(){
  this.result = this.selected.map(person => (person.attendance_id ));
  },
  
  previewImage(event) {
              this.attachment = event.target.files[0]
          },
  
   openJustificar(attendance){
           this.falta = attendance
           
  
  
   this.$vs.loading()
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
            params: {
                          attendance_id:this.falta.attendance_id
                          
                      },
            
        };
        
        
        http
          .get("/attendances/verify_absence", config)
          .then((result) => {
            result
            this.popupJustificar=true
            this.$vs.loading.close()
          })
          .catch((error) => {
           error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right",
            })
          });
    
            
          },
  
  
   async saveJustificar() {
       this.$vs.loading()
       setTimeout( ()=> {
          this.$vs.loading.close()
        }, 2000);
        let token = localStorage.getItem("token");
        let config = {
          headers: {
                           authorization: "Bearer " + token,
                          'content-type': "multipart/form-data"
                      },
        };
        const data = new FormData();
    data.append('attachment', this.attachment);
   data.append('attendance_id', this.falta.attendance_id);
    data.append('descrition', this.description);
  
  
        this.$validator.validateAll();
        await http
          .post("/attendances/absence_justifications", data, config)
          .then((success) => {
            success;
            this.popupJustificar=false,
            this.description="",
            this.attachment="",
              
       
          
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Pedido submetido com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
      },
  
      dataActual(){
        const dataAtual = new Date();
  
  // Obter dia, mês e ano
  const dia = dataAtual.getDate().toString().padStart(2, '0');
  const mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0');
  const ano = dataAtual.getFullYear();
  
  // Concatenar valores em uma string formatada
   this.dataFormatada = `${ano}-${mes}-${dia}`;
  
      },
  
   getEmployees() {
    this.$vs.loading()
  if(this.entry_date==""){
      this.entry_date=this.dataFormatada
      this.exit_date=this.entry_date
  }
    
        //  this.$vs.loading({
        //   container: '#div-with-loading',
        //   scale: 1.0,
        //   type:'sound'
        // })
       
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
          
            params: {
                          type: 1,
                           entry_date:this.entry_date,
                           name:this.name,
                           surname:this.surname,
                           exit_date:this.exit_date,
                           note:this.note,
                           page:this.currentPage,
                          paginate:this.paginate
                          
                      },
            
        };
        
        
        http
          .get("/attendances/attendances", config)
          .then((result) => {
            this.$vs.loading.close()
             this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.employees = result.data.Attendances.data;
            this.totalPage = result.data.Attendances.last_page;
            this.total =  result.data.Attendances.total;
            this.currentPage="1"
  // alert("2")
          })
          .catch((error) => {
            error;
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right",
            })
            this.$vs.loading.close()
            if(error.response.status==401 ){
              this.$router.push('/').catch(() => {})
            }
           
          });
      },
      getEmp() {
    
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
           params: {      status:1,
                          page:this.currentPage,
                          paginate:this.paginate
                      },
        };
        http
          .get("/employees/employees", config)
          .then((result) => {
            this.emps = result.data.Employees.data.reverse();
  // alert("2")
          })
          .catch((error) => {
            error;
            if(error.response.status==401 ){
              this.$router.push('/').catch(() => {})
            }
           
          });
      },
  
  
     
  
    
  },
  
  
  }
  
  </script>
  
  <style lang="scss">
  #avatar-col {
    width: 10rem;
  }
  
  #page-user-view {
    table {
      td {
        vertical-align: top;
        min-width: 140px;
        padding-bottom: .8rem;
        word-break: break-all;
      }
  
      &:not(.permissions-table) {
        td {
          @media screen and (max-width:370px) {
            display: block;
          }
        }
      }
    }
  }
  
  // #account-info-col-1 {
  //   // flex-grow: 1;
  //   width: 30rem !important;
  //   @media screen and (min-width:1200px) {
  //     & {
  //       flex-grow: unset !important;
  //     }
  //   }
  // }
  
  
  @media screen and (min-width:1201px) and (max-width:1211px),
  only screen and (min-width:636px) and (max-width:991px) {
    #account-info-col-1 {
      width: calc(100% - 12rem) !important;
    }
  
    // #account-manage-buttons {
    //   width: 12rem !important;
    //   flex-direction: column;
  
    //   > button {
    //     margin-right: 0 !important;
    //     margin-bottom: 1rem;
    //   }
    // }
  
  }
  
  </style>
  